import { FlywireEnvirnomentVariables } from '../types/gateways/flywire-envirnoment-variables.type';
import { loadFlywireEnvironmentVariables } from './flywire-environment-variables-loader.function';

export const loadPaymentGatewayVariables = <T>(env: FlywireEnvirnomentVariables<T>) => {
  // Only one payments provider, so it's returned flywire variables by default
  return loadFlywireEnvironmentVariables(env);
};
